export const ArrowIcon = () => (
	<svg className="hide-sm" width="15.5rem" height="8.7rem" viewBox="0 0 155 87" fill="none">
		<path
			d="M106.285 15.75V2.57282C106.285 0.828564 108.362 -0.0798224 109.643 1.10427L153.912 42.0314C154.768 42.8232 154.768 44.1768 153.912 44.9685L109.643 85.8957C108.362 87.0798 106.285 86.1714 106.285 84.4272V71.25C106.285 68.4886 104.047 66.25 101.285 66.25H10C4.47715 66.25 0 61.7728 0 56.25V30.75C0 25.2272 4.47714 20.75 9.99999 20.75H101.285C104.047 20.75 106.285 18.5114 106.285 15.75Z"
			fill="#14489D"
		/>
	</svg>
);
